(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tdtHoverImagesInitialized) return;
  window.tdtHoverImagesInitialized = true;
  const hover = window.matchMedia('(any-hover: hover) and (any-pointer: fine)');
  const selector = 'img[data-deferred-hover-image]';
  const hydrate = (root) => {
    if (!hover.matches) return;
    const images = [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
    images.forEach((image) => {
      const media = image.closest('.tdt-hover-media');
      const clearReady = () => media?.classList.remove('tdt-hover-ready');
      const isRealImage = () => image.complete && image.naturalWidth > 0 && image.currentSrc && !image.currentSrc.startsWith('data:');
      const markReady = () => {
        if (!isRealImage()) return;
        if (typeof image.decode === 'function') {
          image.decode().then(() => {
            if (isRealImage()) media?.classList.add('tdt-hover-ready');
          }).catch(clearReady);
        } else {
          media?.classList.add('tdt-hover-ready');
        }
      };
      image.addEventListener('load', markReady);
      image.addEventListener('error', clearReady);
      image.srcset = image.dataset.hoverSrcset;
      image.src = image.dataset.hoverSrc;
      image.removeAttribute('data-deferred-hover-image');
      delete image.dataset.hoverSrcset;
      delete image.dataset.hoverSrc;
      if (image.complete) markReady();
    });
  };
  hydrate(document);
  hover.addEventListener('change', () => hydrate(document));
  new MutationObserver((records) => {
    if (!hover.matches) return;
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) hydrate(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
